import React, { FC } from "react";
import { IconProps } from "@shared/ui/Icon/ui/types";

export const NoFavoritesIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        width="180"
        height="180"
        viewBox="0 0 180 180"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <ellipse cx="89.6849" cy="171.111" rx="48.0912" ry="8.88889" fill="black" />
        <path
            d="M135.837 173.618C137.099 172.823 137.776 171.982 137.776 171.111C137.776 166.202 116.245 162.222 89.6849 162.222C63.1249 162.222 41.5938 166.202 41.5938 171.111C41.5938 171.982 42.2709 172.823 43.5332 173.618C49.3887 169.93 67.8351 167.236 89.6849 167.236C111.535 167.236 129.981 169.93 135.837 173.618Z"
            fill="#666666"
        />
        <path d="M96.4061 109.63H82.332V180H96.4061V109.63Z" fill="url(#paint0_linear_1192_2979)" />
        <path d="M96.4061 109.63H82.332V128.889H96.4061V109.63Z" fill="#BDD6E0" />
        <circle cx="90" cy="61" r="56" fill="white" stroke="#DC4633" strokeWidth="10" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M108.058 47.7781C105.603 45.2992 102.308 43.9393 98.8952 44.0021C95.4537 44.0038 92.3245 46.2471 90.0422 48.7572C87.7363 46.246 84.566 44.0038 81.1047 44.0021C77.6915 43.9393 74.3972 45.2992 71.9423 47.7781C69.4871 50.2574 68.0713 53.6537 68 57.2216V57.2304C68 60.7979 69.3825 64.0106 71.6255 66.389L72.2308 66.9774L88.5305 83.3522C89.3572 84.2161 90.7311 84.2159 91.5576 83.3517L107.79 66.9557C109.11 65.7408 110.167 64.2461 110.892 62.5714C111.619 60.8936 111.997 59.0731 112 57.2312L112 57.2216C111.929 53.6537 110.513 50.2574 108.058 47.7781ZM107.718 57.2343C107.717 59.8426 106.589 62.212 104.81 63.8592L90.0431 78.7515L75.224 63.8712L74.7404 63.4097C73.9648 62.6037 73.3477 61.6437 72.9255 60.5845C72.5027 59.5237 72.2839 58.385 72.2822 57.2341C72.3045 56.0392 72.5506 54.861 73.006 53.7668C73.4619 52.6713 74.1186 51.682 74.9375 50.8549C75.7564 50.0278 76.7216 49.3792 77.7773 48.9451C78.8331 48.5111 79.9593 48.2999 81.092 48.3231H81.1007C82.5339 48.3231 83.9046 48.9869 85.1485 49.9782C86.3903 50.9676 87.4704 52.2556 88.3128 53.4347C88.7233 54.0092 89.3576 54.3281 90.0417 54.3287C90.3808 54.3318 90.7154 54.2525 91.0191 54.0981C91.3234 53.9434 91.5879 53.7178 91.7928 53.4402L91.7982 53.4325C92.6312 52.2515 93.6843 50.9642 94.9011 49.9756C96.1194 48.9858 97.4673 48.3232 98.8992 48.3232L98.9079 48.323C100.041 48.2998 101.167 48.5111 102.223 48.9451C103.278 49.3792 104.243 50.0278 105.062 50.8549C105.881 51.682 106.538 52.6713 106.994 53.7668C107.449 54.8611 107.695 56.0393 107.718 57.2343Z"
            fill="#2A2F4D"
        />
        <defs>
            <linearGradient
                id="paint0_linear_1192_2979"
                x1="82.332"
                y1="145.923"
                x2="96.4061"
                y2="145.923"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E6EBF4" />
                <stop offset="0.381479" stopColor="white" />
                <stop offset="0.666667" stopColor="white" />
                <stop offset="1" stopColor="#E6EBF4" />
            </linearGradient>
        </defs>
    </svg>
);